import * as React from 'react'

const SvgForegroundIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5.5H5.25C4.56.502 4.002 1.06 4 1.75v8.75c.002.69.56 1.248 1.25 1.25H16.5a1.254 1.254 0 001.25-1.25V1.75A1.254 1.254 0 0016.5.5zm0 10H5.25V1.75H16.5v8.75zm-6.25 3.75H1.5V8h1.25V6.75H1.5C.81 6.752.252 7.31.25 8v6.25c.002.69.56 1.248 1.25 1.25h8.75a1.254 1.254 0 001.25-1.25V13h-1.25v1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgForegroundIcon
